const getWindow = () =>
  global.window || {
    location: { hostname: 'default', port: '666', protocol: 'http' },
  };

export default getWindow;
